import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import './style.scss';

const claimPageSkeleton = () => {
  return (
    <div className='pt-4 '>
       <Skeleton  variant="text" width={250} height={60}/>
     <div className='mx-5'>
      <div className='d-flex justify-content-around mt-1'>
      <Skeleton className={'col-12'} variant="rect"height={100} />
      </div>
      <div className='d-flex justify-content-around mt-1 '>
      <Skeleton className={'col-12'} variant="rect"height={100} />
      </div>
      <div className='d-flex justify-content-around mt-1 '>
      <Skeleton className={'col-12'} variant="rect"height={100} />
      </div>
      </div>
    </div>
  );
};
export default claimPageSkeleton;